import "./ClientPieChart.css";
import { useEffect, useState } from "react";
import * as echarts from "echarts";
import Url from "../../Services/Url";
import { PublicGet } from "../../Services/Server";
import User from "../../Services/User";

const Piechart = ({ chartId, dashboardType = "maritime" }) => {
	const currentDate = new Date();
	const [filterYear, setFilterYear] = useState(currentDate.getFullYear());
	const [filterMonth, setFilterMonth] = useState(currentDate.getMonth() + 1);
	const [myChart, setChart] = useState(null);
	const [counts, setCounts] = useState(null);
	const [data, setData] = useState([]);
	const companyId = User.getCompany().id;

	const getChartData = () => {
		if (!counts) return [];
		return [
			{ value: counts.maintenanceCount, name: "Maintenance", itemStyle: { color: "#3CC3DF" } },
			{ value: counts.installationCount, name: "Installations", itemStyle: { color: "#FFAE4C" } },
			{ value: counts.surveyCount, name: "Survey", itemStyle: { color: "#FF928A" } },
			{ value: counts.repairCount, name: "Repairs", itemStyle: { color: "#8979FF" } },
			{ value: counts.decommissioningCount, name: "Decommissioning", itemStyle: { color: "#537FF1" } },
		];
	};

	useEffect(() => {
		const chartDom = document.getElementById(chartId);
		if (chartDom) {
			const chartInstance = echarts.init(chartDom);
			setChart(chartInstance);
		}
	}, [chartId]);

	useEffect(() => {
		const fetchCounts = () => {
			try {
				//  Use the appropriate endpoint based on dashboardType
				const url =
					dashboardType === "enterprise"
						? Url.public.getEntTaskTypeCounts(filterYear, filterMonth, companyId)
						: Url.public.getMrtTaskTypeCounts(filterYear, filterMonth, companyId);

				PublicGet(url)
					.then((response) => {
						setCounts(response.data || response);
					})
					.catch((error) => console.error("Error fetching counts:", error));
			} catch (error) {
				console.error("Error in fetchCounts:", error);
			}
		};

		fetchCounts();
	}, [filterYear, filterMonth, dashboardType, companyId]);

	useEffect(() => {
		if (counts && myChart) {
			const dt = getChartData();
			setData(dt);
			const sum = dt.reduce((a, b) => a + (b.value || 0), 0);

			const option = {
				tooltip: { trigger: "item" },
				series: [
					{
						name: "Job Type",
						type: "pie",
						radius: ["60%", "80%"],
						center: ["35%", "50%"],
						data: dt,
						label: { show: false },
						labelLine: { show: false },
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: "rgba(0, 0, 0, 0.5)",
							},
						},
					},
				],
				graphic: [
					{
						type: "group",
						left: "35%",
						top: "50%",
						z: 10,
						bounding: "raw",
						children: [
							{
								type: "text",
								style: {
									text: `${sum}`,
									fill: "rgba(14, 52, 101, 0.75)",
									fontSize: 40,
									fontWeight: "bold",
									textAlign: "center",
									textVerticalAlign: "middle",
								},
								left: "center",
								top: -30,
							},
							{
								type: "text",
								style: {
									text: "Total Jobs",
									fill: "#0e3465",
									fontSize: 20,
									textAlign: "center",
									textVerticalAlign: "middle",
								},
								left: "center",
								top: 20,
							},
						],
					},
				],
			};

			myChart.setOption(option);
		}
	}, [counts, myChart]);

	const handleYearChange = (e) => setFilterYear(Number(e.target.value));
	const handleMonthChange = (e) => setFilterMonth(Number(e.target.value));

	const currentYearVal = currentDate.getFullYear();
	const yearOptions = Array.from({ length: currentYearVal - 2022 }, (_, i) => 2023 + i);
	const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

	return (
		<div className="piechart-container">
			<div className="piechart-header">
				<h3>Job Type</h3>
				<div className="filter-controls">
					<select value={filterMonth} onChange={handleMonthChange}>
						{monthNames.map((m, i) => (
							<option key={m} value={i + 1}>{m}</option>
						))}
					</select>
					<select value={filterYear} onChange={handleYearChange}>
						{yearOptions.map((y) => (
							<option key={y} value={y}>{y}</option>
						))}
					</select>
				</div>
			</div>

			<div className="piechart-body">
				<div id={chartId} className="chart-area"></div>
				<div className="chart-legend">
					{data.map((dt, index) => (
						<div className="legend-item" key={index}>
							<div className="legend-left">
								<span className="dot" style={{ backgroundColor: dt.itemStyle.color }}></span>
								<span className="legend-label">{dt.name}</span>
							</div>
							<span className="legend-value">{dt.value || 0}</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

Piechart.defaultProps = { chartId: "PieChart" };
export default Piechart;
